import React from 'react';
import { useNavigate } from 'react-router-dom';
import ReceiverInstructions from './ReceiverInstructions';
import './Guide.css';

const ReceiverGuide = () => {
  const navigate = useNavigate();

  return (
    <div className="guide-page">
      <div className="guide-header">
        <button 
          className="back-button"
          onClick={() => navigate('/')}
        >
          ← Back to Role Selection
        </button>
        <div className="guide-title-section">
          <h1>🎧 Participant Guide</h1>
          <p>Complete guide for joining and receiving real-time translations</p>
        </div>
        <div className="guide-actions">
          <button 
            className="start-button"
            onClick={() => navigate('/receiver')}
          >
            Join Session →
          </button>
        </div>
      </div>
      
      <div className="guide-content">
        <ReceiverInstructions />
      </div>
    </div>
  );
};

export default ReceiverGuide;